import { Alert, Badge } from 'react-bootstrap';
import {
  SETUP_SECTIONS,
  type GoogleSetupItem,
} from '../lib/google-setup-guide';

function setupItemKey(item: GoogleSetupItem): string {
  if (typeof item === 'string') return item;
  return `${item.before ?? ''}${item.link.label}${item.after ?? ''}`;
}

function SetupItemText({ item }: { item: GoogleSetupItem }) {
  if (typeof item === 'string') return item;
  return (
    <>
      {item.before}
      <a href={item.link.href} target="_blank" rel="noopener noreferrer">
        {item.link.label}
      </a>
      {item.after}
    </>
  );
}

/** One bordered box per Google Cloud setup step (onboarding + help drawer). */
export function GoogleSetupSectionsList({
  className = '',
  showPropagateWarning = true,
}: {
  className?: string;
  showPropagateWarning?: boolean;
}) {
  return (
    <div className={className}>
      <div className="d-flex flex-column gap-3">
        {SETUP_SECTIONS.map((section, index) => (
          <div
            key={section.title}
            className="border rounded-3 p-3 bg-body-tertiary"
          >
            <h3 className="fs-0 d-flex align-items-center gap-2 mb-2 fw-semibold text-body">
              <Badge bg="primary" pill>
                {index + 1}
              </Badge>
              {section.title}
            </h3>
            <ul className="d-flex flex-column gap-2 mb-2 ps-3 text-body lh-lg fs--1">
              {section.items.map((item) => (
                <li key={setupItemKey(item)}>
                  <SetupItemText item={item} />
                </li>
              ))}
            </ul>
            {section.link && (
              <a
                href={section.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {section.linkLabel}
              </a>
            )}
            {section.links?.map((link) => (
              <div key={link.href}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              </div>
            ))}
          </div>
        ))}
      </div>
      {showPropagateWarning && (
        <Alert variant="warning" className="small mb-0 mt-3">
          پس از افزودن کاربر در Search Console، ممکن است شناسایی کامل توسط
          APIهای گوگل <strong>۱ تا ۲ ساعت</strong> طول بکشد. اگر خطای عدم
          دسترسی دیدید، کمی صبر کنید و دوباره «بررسی دسترسی» را بزنید.
        </Alert>
      )}
    </div>
  );
}
